import { useContext, useEffect } from 'react';
import { AppContext } from '../provider/AppContextProvider';
import { Platform } from '../helper/interfaces';
import { applyDeviceFontScaleForPlatform } from '../helper/deviceFontScale';

/**
 * Pages Router counterpart of app/components/DeviceFontScaleGate.tsx — same
 * behaviour, reading the legacy AppContext. See helper/deviceFontScale.ts.
 *
 * Renders nothing.
 */
export function DeviceFontScaleGate() {
  const { appInfo } = useContext(AppContext);
  const platform = appInfo?.platform;

  useEffect(() => {
    if (!platform || platform === Platform.Unknown) return;
    applyDeviceFontScaleForPlatform(platform);
  }, [platform]);

  return null;
}
